module.exports = __webpack_public_path__ + "static/media/pdr4.d7fcf770.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/teacher_resources/pdr4.png
// module id = 1176
// module chunks = 0